import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=321d0944&scoped=true&"
import script from "./Routes.vue?vue&type=script&lang=ts&"
export * from "./Routes.vue?vue&type=script&lang=ts&"
import style0 from "./Routes.vue?vue&type=style&index=0&id=321d0944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321d0944",
  null
  
)

export default component.exports